/* eslint-disable no-underscore-dangle */
import { ApolloClient, ApolloLink, InMemoryCache } from '@apollo/client';
import { createUploadLink } from 'apollo-upload-client';
import { API_URL } from 'appenv';
import possibleTypes from 'possibleTypes.json';

import 'isomorphic-fetch';
import createErrorLink from './createErrorLink';

const link = ApolloLink.from([
  createErrorLink(),
  createUploadLink({
    uri: API_URL,
    credentials: 'omit',
    headers: {
      'keep-alive': 'true',
    },
  }),
]);

/*
  References:
  - https://www.apollographql.com/docs/react/data/fragments/#using-fragments-with-unions-and-interfaces
  - https://www.apollographql.com/docs/react/data/fragments/#generating-possibletypes-automatically
 */
const cache = new InMemoryCache({
  possibleTypes,
});

const client = new ApolloClient({
  link,
  cache,
  connectToDevTools: true,
});

export default client;
